<template>
  <b-card no-body class="border-0 shadow p-2 mb-4">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-clock-o" />
        UBICACIONES TEMPORALES
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="12">
          <b-table
            responsive
            striped
            hover
            small
            :items="temporaryLocations"
            :fields="columns"
            thead-tr-class="table-active"
            class="mb-0"
            empty-text="No hay ubicaciones temporales para mostrar"
            show-empty
          >
            <template v-slot:cell(moduleCreated)="data">
              <b-badge
                v-if="data.item.checklist.length"
                variant="primary"
                v-text="'Inspecciones'"
              />
              <b-badge v-else variant="success" v-text="'Tickets'" />
            </template>

            <template v-slot:cell(parentName)="data">
              <span v-if="getParentLocationName(data.item)">
                {{ getParentLocationName(data.item) }}
              </span>
              <span v-else class="text-muted">
                Sin ubicación padre
              </span>
            </template>

            <template v-if="validarPermisoComponente('empresa-editar-ubicaciones')" v-slot:cell(actions)="data">
              <el-tooltip content="Aprobar" placement="bottom" effect="light">
                <a class="botonProduct" @click="setModalLocal(data.item)">
                  <i class="fa fa-check text-success" />
                </a>
              </el-tooltip>

               <el-tooltip content="Rechazar" placement="bottom" effect="light">
                <a class="botonProduct" @click="rechazarUbicacion(data.item)">
                  <i class="fa fa-close text-danger ml-3" />
                </a>
              </el-tooltip>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-body>
    <createLocationModal />
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import createLocationModal from "./modal";
import { validarPermisoComponente } from "@/plugins/acl";
import Swal from "sweetalert2";

export default {
  components: {
    createLocationModal,
  },
  name: "temporaryLocations",
  data() {
    return {
      temporaryLocation: null,
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  watch: {
    newLocation: {
      handler: async function (val) {
        if (val && this.temporaryLocation) {
          await this.confirmTemporaryLocationLocal();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("location", ["temporaryLocations", "selectedUbicacion", "newLocation", "nivelesActivos", "locationsActive"]),
    columns() {
      const columnsBase = [
        {
          key: "name",
          label: "Nombre",
          sortable: true,
        },
        {
          key: "parentName",
          label: "Ubicación_padre",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Fecha_de_creación",
          tdClass: "text-uppercase",
          thStyle: "width: 200px; max-width:200px",
          sortable: true,
        },
        {
          key: "moduleCreated",
          label: "Módulo_de_creación",
          tdClass: "text-uppercase",
          thStyle: "width: 180px; max-width:180px",
          sortable: true,
        },
      ];

      if(this.validarPermisoComponente('empresa-editar-ubicaciones')){
        columnsBase.push({
          key: "actions",
          label: "Opciones",
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: "width: 120px; max-width:120px",
        });
      }

      return columnsBase;
    },
  },
  methods: {
    ...mapActions("location", [
      "listarNivelActivos",
      "listLocationsActive",
      "confirmTemporaryLocation",
      "listLevels",
      "listarUbicaciones",
      "arbolUbicacionesEmpresa",
      "getTemporaryLocations",
    ]),
    ...mapMutations("location", ["setModal", "setSelectedUbicacion", "setModuleCreated"]),
    async setModalLocal(location) {
      this.temporaryLocation = location;
      this.setModuleCreated("temporaryLocations");
      await this.listarNivelActivos();
      await this.listLocationsActive();
      
      
      // Extraer datos del ticket para pre-cargar el modal
      let parentLocationId = null;
      let parentLevel = null;
      let childLevelId = null;
      let parentLocationName = null;
      
      if (location.tickets && location.tickets.length > 0) {
        const ticket = location.tickets[0];
        
        if (ticket.locations && ticket.locations.length > 0) {
          parentLocationId = ticket.locations[0];
          
          // Buscar la ubicación padre
          if (this.locationsActive && this.locationsActive.length > 0) {
            const parentLocation = this.locationsActive.find(loc => loc.id === parentLocationId);
            if (parentLocation) {
              parentLocationName = parentLocation.description;
              
              // obtiene el nivel del padre de diferentes formas para evitar errores
              if (parentLocation.location_level && parentLocation.location_level.level) {
                parentLevel = parentLocation.location_level.level;
              } else if (parentLocation.slq_locations_level_id) {
                // Buscar el nivel por ID en nivelesActivos
                if (this.nivelesActivos && this.nivelesActivos.data) {
                  const parentLevelObj = this.nivelesActivos.data.find(nivel => nivel.id === parentLocation.slq_locations_level_id);
                  if (parentLevelObj) {
                    parentLevel = parentLevelObj.level;
                  }
                }
              }              
              // Buscar el nivel hijo (padre + 1) en nivelesActivos
              if (parentLevel && this.nivelesActivos && this.nivelesActivos.data) {
                const childLevel = this.nivelesActivos.data.find(nivel => nivel.level === parentLevel + 1);
                if (childLevel) {
                  childLevelId = childLevel.id;
                }
              }
            }
          }
        }
      }
      
      // Preparar datos para el modal
      let data = {
        description: location.name,
        active: 1,
        parent: parentLocationId ? true : false,
        slq_location_id: parentLocationId,
        slq_company_id: location.company_id,
        slq_locations_level_id: childLevelId,
        // Datos adicionales para validación
        _parentLevel: parentLevel,
        _childLevelId: childLevelId,
        _parentLocationName: parentLocationName
      };
      
      this.setSelectedUbicacion(data);
      this.setModal(true);
    },
    getParentLocationName(location) {
      if (location.tickets && location.tickets.length > 0) {
        const ticket = location.tickets[0];
        if (ticket.list_locations && ticket.list_locations.length > 0) {
          return ticket.list_locations[0].description;
        }
      }
      return null;
    },
    /**
     * Rechaza (inactiva) una ubicación temporal.
     * 
     * @param location 
     */
    async rechazarUbicacion(location) {
      const result = await Swal.fire({
        title: '¿Está seguro de que desea rechazar esta ubicación temporal?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, rechazar',
        cancelButtonText: 'No',
        reverseButtons: true
      });
      if (!result.isConfirmed) return;

      await this.confirmTemporaryLocation({
        temporary_location_id: location.id,
        company_id: location.company_id,
        accion: 'rechazar'
      });
      await this.getTemporaryLocations();
    },
    async confirmTemporaryLocationLocal() {
      await this.confirmTemporaryLocation({
        slq_location_id: this.newLocation.data.id,
        company_id: this.temporaryLocation.company_id,
        temporary_location_id: this.temporaryLocation.id,
      });
      await this.listLevels();
      await this.listarUbicaciones();
      await this.arbolUbicacionesEmpresa();
      await this.getTemporaryLocations();
    },
  },
};
</script>

<style scoped></style>
